import validate from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/node_modules/nuxt/dist/pages/runtime/validate.js";
import current_45module_45global from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/middleware/currentModule.global.js";
import is_45authenticated_45global from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/middleware/isAuthenticated.global.js";
import scroll_45position_45global from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/middleware/scrollPosition.global.js";
import manifest_45route_45rule from "/home/forge/develop.oase-aej.de/releases/20261105103043/client/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  current_45module_45global,
  is_45authenticated_45global,
  scroll_45position_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/middleware/auth.ts"),
  "can-access-route": () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/middleware/canAccessRoute.js"),
  guest: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/middleware/guest.ts"),
  unverified: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/middleware/unverified.ts"),
  verified: () => import("/home/forge/develop.oase-aej.de/releases/20261105103043/client/middleware/verified.ts")
}